export default __webpack_public_path__ + "static/media/pass.e83a443c.jpeg";